import { setKeyTerm } from "../store/actions";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

export const useKeyTerms = () => {
  const dispatch = useDispatch();
  const showKeyTerm = (e) => {
    e.preventDefault();
    dispatch(setKeyTerm(e.target.dataset.term));
  };

  useEffect(() => {
    document
      .querySelectorAll("a.term-link")
      .forEach((el) => el.addEventListener("click", showKeyTerm));

    return () => {
      document
        .querySelectorAll("a.term-link")
        .forEach((el) => el.removeEventListener("click", showKeyTerm));
    };
  });
};
